import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { VariableService } from '@service/variable.service';
import { VariableApproval } from '@entity/variable';

export const VariableApprovalResolve: ResolveFn<VariableApproval> = (route) => {
  return inject(VariableService).getApproval(route.params.id);
};
